import _DTO from "./_DTO";
import ProtocolDTO from "./ProtocolDTO";
import ConfigurationDTO from "./ConfigurationDTO";

export default class IOIslandDTO extends _DTO {

  constructor(ioIsland) {
    super();
    this.slot = ioIsland.slot;
    this.protocol = IOIslandDTO.getMappedOrDefault(ioIsland, 'protocol', null, data => new ProtocolDTO(data));
    this.configuration = IOIslandDTO.getMappedOrDefault(ioIsland, 'configuration', null, data => new ConfigurationDTO(data));
  }
}
